import axios from '../../v2/app/services/axiosService';
import {orderBy} from 'lodash';
import Path from 'path-browserify';

export default {
  mimeTypes() { // MLD-2052
    return [
      // @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
      'image/gif', // MLD-5909
      'image/png',
      'image/jpeg',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'video/mpeg',
      'video/mp4',
      'text/calendar', // MLD-5909
      'text/plain',
      'application/json',
      // MLD-3033
      'image/vnd.dwg',
      'application/dwg',
      'application/dxf',
      'application/x-autocad',
      'application/x-dxf',
      'application/octet-stream',
      'application/zip', // MLD-6574
    ].join(',');
  },
  async createDirectory(form, basePath) { // MLD-5628
    const path = Path.join(basePath, form.folder);
    const config = {
      data: {
        path,
      },
    }
    const response = await form.post(`/api/assets/directory`, config);
    return response.data;
  },
  async makeDirectory(path) {
    const response = await axios.post(`/api/assets/directory`, {path});
    return response.data;
  },
  async deleteDirectory(path) {
    const response = await axios.post(`/api/assets/directory/delete`, {path});
    return response.data;
  },
  fakeDeleteDirectory(path) {
    return Promise.resolve([]);
  },
  fakeDeleteFiles(files) {
    return Promise.resolve([]);
  },
  async deleteFiles(files) {
    const response = await axios.post(`/api/assets/delete`, {files});
    return response.data;
  },
  async getAllImages(path = '') { // MLD-2949
    const options = {
      params: {
        path,
      }
    }
    const response = await axios.get(`/api/assets/all-images`, options);
    return orderBy(response.data, ['slug'], ['asc']);
  },
  async getAssets(path = '') {
    const options = {
      params: {
        path,
      }
    }
    const response = await axios.get(`/api/assets`, options);
    return orderBy(response.data, ['slug'], ['asc']);
  },
  async upload(files, path) {
    const formData = new FormData();
    formData.append('path', path);
    files.forEach(file => {
      formData.append('file[]', file, file.name);
    })
    const response = await axios.post(`/api/assets`, formData);
    return response.data;
  }
}
